import * as React from "react"
import { Box } from "@mui/material"
import { Profile } from "./UserProfile"

import { makeStyles, useTheme } from "@mui/styles"

export const SidebarContext = React.createContext({
    width: "285px",
    collapsewidth: "80px",
    textColor: "#8D939D",
    isCollapse: false,
    themeColor: "#5d87ff",
})

const useStyles = makeStyles((theme) => ({
    containerWithScroll: {
        overflowY: "scroll",
        ...theme.scrollbarStyles,
    },
}))

let handleLogout = () => {
    alert("Logout Successfully")
}

const Sidebar = ({
    children,
    width = "285px",
    collapsewidth = "80px",
    textColor = "#2b2b2b",
    isCollapse = false,
    themeColor = "#5d87ff",
    mode = "light",
    direction = "ltr",
    userName = "",
    designation = "",
    showProfile = true,
    userimg = "",
    onLogout = handleLogout,
}) => {
    const classes = useStyles()
    const theme = useTheme()
    const [isSidebarHover] = React.useState(false)
    const toggleWidth = isCollapse && !isSidebarHover ? collapsewidth : width

    if (mode === "dark") {
        textColor = "rgba(255,255,255, 0.9)"
    }

    return (
        <Box
            dir={direction}
            className={classes.containerWithScroll}
            sx={{
                width: toggleWidth,
                flexShrink: 0,
                fontFamily: "inherit",
                overflowX: "hidden",
                position: "relative",
                transition: "width 0.3s ease",
                zIndex: 1200,
                backgroundColor: theme.palette.fancyBackground,
            }}
        >
            <Box
                sx={{ width: toggleWidth - 20, transition: "width 0.3s ease" }}
            >
                <SidebarContext.Provider
                    value={{
                        textColor,
                        isCollapse,
                        width,
                        collapsewidth,
                        themeColor,
                    }}
                >
                    {children}
                </SidebarContext.Provider>
                <Box
                    sx={{
                        position: "sticky",
                        bgcolor: theme.palette.fancyBackground,
                        bottom: 0,
                    }}
                >
                    {showProfile ? (
                        <Profile
                            userName={userName}
                            designation={designation}
                            userimg={userimg}
                            isCollapse={isCollapse}
                            onLogout={onLogout}
                        />
                    ) : null}
                </Box>
            </Box>
        </Box>
    )
}

export { Sidebar }
